/*
 * Copyright (c) 2024. Tooling Team
 */

import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { toTitleCase } from "../utils/funcs";
import { SelectInput } from "@uhg-abyss/web/ui/SelectInput";

export default function EIPMapAttributes(props) {
  const [attrs, setAttrs] = useState({});

  useEffect(() => {
    setAttrs(props.attributes);
  });

  //we want to append the status onto the version if it's the selected version
  const formatVersion = (version) => {
    let formattedVersion;
    if (String(version) === String(props.mapVersion)) {
      //status is stored uppercase, desired text is only first letter capital
      formattedVersion = version + " - " + toTitleCase(props.mapStatus);
    } else {
      formattedVersion = version;
    }
    return formattedVersion;
  };

  //selectInput requires an object
  const formatOptions = (options) => {
    let formattedOptions;
    formattedOptions = options.map((v) => ({
      value: v,
      label: formatVersion(v),
    }));
    return formattedOptions;
  };

  const versionSelectKey = [
    props.versionSelectResetKey,
    props.mapVersion,
    props.mapStatus,
    ...(props.mapVersionList || []),
  ].join("-");

  return (
    <div className="d-flex flex-grow-1 justify-content-evenly p-2 selected-attributes-box">
      {Object.keys(attrs).map((key, index) => {
        const obj = attrs[key];

        return (
          <div key={index} className="d-flex justify-content-center mt-2">
            <div className="d-flex align-items-center flex-column">
              <div className="attr-name">
                {obj.name.replaceAll("_", " ")}{" "}
                {obj.changed ? (
                  <div className="badge bg-warning">Changed</div>
                ) : (
                  ""
                )}
                {obj.updated && !obj.changed ? (
                  <div className="badge bg-success">Updated</div>
                ) : (
                  ""
                )}
              </div>
              <div className="d-flex align-items-center p-2">{obj.value}</div>
            </div>
          </div>
        );
      })}
      <div
        key={attrs.length + 1}
        className="d-flex justify-content-center mt-2"
      >
        <div className="d-flex align-items-center flex-column">
          <div className="attr-name">Version</div>
          <div className="d-flex align-items-center p-2">
            <SelectInput
              key={versionSelectKey}
              label="Version"
              hideLabel
              placeholder={props.mapVersion}
              value={props.mapVersion}
              onChange={(event) => props.handleVersionChange(event)}
              options={formatOptions(props.mapVersionList)}
              isDisabled={props.disableVersion}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

EIPMapAttributes.propTypes = {
  mapStatus: PropTypes.string,
  mapVersion: PropTypes.number,
  mapVersionList: PropTypes.array,
  handleVersionChange: PropTypes.func,
  versionSelectResetKey: PropTypes.number,
  disableVersion: PropTypes.bool,
  attributes: PropTypes.object,
  addAttrOnClick: PropTypes.func,
};
